import React from 'react';
import { Routes } from 'utils/routes';
import { useRouter } from 'next/router';

const KlatpensionArticlesPreviews = ( {  }) => {
    const router = useRouter();

    return (
        <article className="articlePreviews">
            <section>
                <div style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-8-klatpension.jpg)' }} onClick={ () => router.push(Routes.Articles.Article('red-din-klatpension-og-faa-udsigt-til-en-bedre-seniortilvaerelse')) }></div>
                <div>
                    <h3> Undgå at dine klatpensioner bliver spist af gebyrer</h3>
                    <p>
                        Vi danskere har 7 mia. kroner stående i klatpensioner. Altså penge som forsvinder helt af sig selv, hvis ikke du gør noget ved dem. Vi har gjort det nemt for dig at tage hånd
                        om dine klatpensioner, så du kan se dem yngle i stedet for at se dem gå op i røg.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('red-din-klatpension-og-faa-udsigt-til-en-bedre-seniortilvaerelse')) }>Læs mere</a>
                </div>
            </section>
            <section>
                <div style={{ backgroundImage: 'url(/static/gfx/content/articles/penly-article-10-rene-holten-poulsen-action-hero.jpg)' }} onClick={ () => router.push(Routes.Articles.Article('en-nedsparingsraadgivning-gav-birthe-300000-kr-mere-til-pension')) }></div>
                <div>
                    <h3>René Holten Poulsen fandt 8.600 kr. – tjek selv, om du har penge, der venter på at blive fundet</h3>
                    <p>
                        Tænk på dine 3 nærmeste venner. Fortæl dem nu, at mindst én af jer 4 har 15.000 kr., som I vil miste, hvis ikke I gør noget ved det nu. I ville helt sikkert alle sammen tjekke hvem af jer det var.
                        <br/>
                        <br/>
                        Langt de færreste er klar over, at de har klatpensioner, som de risikerer at miste. I Danmark har vi tilsammen ca. 7 mia. kr. i de helt små glemte pensioner, der er i fare for at gå i nul.
                        <br/>
                        <br/>
                        Her skal du møde René Holten Poulsen, som ved hjælp af Penly fandt 8.600 kr. på en klatpension, som ville være forsvundet, hvis ikke han havde gjort noget ved dem.
                    </p>
                    <a onClick={ () => router.push(Routes.Articles.Article('rene-holten-poulsen-fandt-8600-kr')) }>Læs mere</a>
                </div>
            </section>

        </article>
    );
};

KlatpensionArticlesPreviews.defaultProps = {};
KlatpensionArticlesPreviews.propTypes = {};

export default KlatpensionArticlesPreviews;
